// extracted by mini-css-extract-plugin
export default {"sidebar":"style_sidebar__Z9XUO","expanded":"style_expanded__pvwlr","toggleIcon":"style_toggleIcon__YOpQB"};